import React, { useState } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

// "Request a report" form. Used on the Reports hub (paid users + staff) and
// on the supplier "coming soon" gate. Posts to /feedback/report-request,
// which emails info@tryzilch.com.
export default function RequestReportForm({ heading = 'Request a report', helper, defaultReportType = '' }) {
  const [reportType, setReportType] = useState(defaultReportType);
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const trimmed = message.trim();
    if (!trimmed) {
      setError('Tell us what report you need.');
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API_BASE_URL}/feedback/report-request`, {
        message: trimmed,
        reportType: reportType.trim(),
      });
      setSuccess(true);
    } catch (err) {
      setError(err?.response?.data?.error || 'Failed to send your request. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (success) {
    return (
      <div
        className="text-center"
        style={{
          background: '#f0fdf4',
          border: '1px solid #bbf7d0',
          borderRadius: 12,
          padding: 32,
        }}
      >
        <div style={{ fontSize: 36, marginBottom: 8 }}>✓</div>
        <div className="fw-semibold mb-1" style={{ fontSize: 17 }}>Thanks — your request is in.</div>
        <div className="text-muted" style={{ fontSize: 14 }}>
          The Zilch team will get back to you at the email on your account.
        </div>
      </div>
    );
  }

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        background: '#fff',
        border: '1px solid #e4e4e7',
        borderRadius: 14,
        padding: 24,
        boxShadow: '0 1px 2px rgba(0,0,0,0.04), 0 8px 24px rgba(0,0,0,0.04)',
      }}
    >
      <h2 className="h6 fw-bold mb-1">{heading}</h2>
      {helper && <p className="text-muted mb-3" style={{ fontSize: 13 }}>{helper}</p>}

      <label className="form-label small text-muted mb-1">
        Report type <span className="text-muted fw-normal">(optional)</span>
      </label>
      <input
        type="text"
        className="form-control mb-3"
        placeholder="e.g. Monthly distributor activity"
        value={reportType}
        onChange={(e) => setReportType(e.target.value)}
        disabled={submitting}
      />

      <label className="form-label small text-muted mb-1">
        What would help you?
      </label>
      <textarea
        className="form-control"
        rows={5}
        maxLength={4000}
        placeholder="Describe the report you'd like including what data, what cadence, how you'd use it…"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        disabled={submitting}
        style={{ resize: 'vertical' }}
      />
      <div className="text-end text-muted mt-1" style={{ fontSize: 12 }}>{message.length}/4000</div>

      {error && <div className="alert alert-danger mt-2 mb-0">{error}</div>}

      <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
        
        <button type="submit" className="btn btn-dark" disabled={submitting}>
          {submitting ? 'Sending…' : 'Send request'}
        </button>
      </div>
    </form>
  );
}
